<template>
  <div class="card-content"
       :class="{'table-error' : avertissement }">
    <div class="columns is-multiline">
      <div class="column is-narrow mgv-auto width-75px">
        <b-field>
          <qd-checkbox :value="allDemandeSelected"
                      class="mgr-0"
                      @input="selectAll(!allDemandeSelected)">
          </qd-checkbox>
          <div class="is-cursor-pointer mgt-3px"
               @click="openDemandes = !openDemandes">
            <b-icon :icon="openDemandes ? 'chevron-down' : 'chevron-right'"
                    type="is-default">
            </b-icon>
          </div>
        </b-field>
      </div>
      <div class="column is-2">
        <router-link-blank :to="{ name: 'c.bodac.devis',
                    params: { id: devis.id }}"
                           class-message="is-size-5"
                           :message="devis.code"/>
        <p class="has-text-weight-bold"> {{ getEtatDevis }} </p>
        <p class="has-text-default">
          {{ devis.dateDevisCommande | formatDate }}
        </p>
      </div>
      <div class="column is-2">
        <b-tooltip class="width-100percent"
                   :label="annonceurs"
                   multiline
                   type="is-warning"
                   position="is-left">
          <b-field :label="$t('listeDemandeTempo.card.annonceur')" class="width-100percent "
                   custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
            <p class="has-text-link has-text-weight-bold ellipsis">
              {{ annonceurs }}
            </p>
          </b-field>
        </b-tooltip>
      </div>
      <div class="column is-2">
        <b-tooltip class="width-100percent"
                   :label="payeurs"
                   multiline
                   type="is-warning"
                   position="is-left">
          <b-field :label="$t('listeDemandeTempo.card.payeur')" class="width-100percent "
                   custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
            <p class="has-text-link has-text-weight-bold ellipsis">
              {{ payeurs }}
            </p>
          </b-field>
        </b-tooltip>
      </div>
      <div class="column is-2">
        <b-tooltip class="width-100percent"
                   :label="getNameCommercial"
                   multiline
                   type="is-warning"
                   position="is-left">
          <b-field :label="$t('listeDemandeTempo.card.commercial')" class="width-100percent"
                   custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
            <p class="has-text-link has-text-weight-bold ellipsis">
              {{ getNameCommercial }}
            </p>
          </b-field>
        </b-tooltip>
      </div>
      <div class="column is-2" v-if="societeActive.agences.length > 1">
        <b-field :label="$t('listeDemandeTempo.card.agenceProduit')" class="width-100percent"
                  custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
          <p class="has-text-link has-text-weight-bold ellipsis">
            {{ getAllAgenceLibelle }}
          </p>
        </b-field>
      </div>
    </div>
    <div v-if="openDemandes">
      <div v-for="(demande, index) in demandes" :key="index"
           class="card mgb-20px">
        <demande-tempo :demande="demande"
                       @updateEtatObtenuReponse="updateEtatObtenuReponse"
                       @updateSelected="makeSelect">
        </demande-tempo>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';

import routerLinkBlank from '@/components/general/routerLinkBlank';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import demandeTempo from '@/components/bodac/demandeTempo/demandeTempo';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    devis: {
      type: Object,
      required: true,
    },
    allDemandes: {
      type: Array,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      openDemandes: false,
    };
  },
  components: {
    routerLinkBlank,
    demandeTempo,
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActive: 'societeActive',
    }),
    demandes() {
      return this.allDemandes.filter((demande) => {
        return demande.devisId === this.devis.id;
      });
    },
    annonceurs() {
      const intervantsFilter = this.devis.intervenants.filter((intervenant) => {
        return intervenant.annonceur;
      });
      return intervantsFilter.map((intervenant) => intervenant.nomCommercial).join(', ');
    },
    payeurs() {
      const intervantsFilter = this.devis.intervenants.filter((intervenant) => {
        return intervenant.payeur;
      });
      return intervantsFilter.map((intervenant) => intervenant.nomCommercial).join(', ');
    },
    avertissement() {
      return this.demandes.some((demande) => { return demande.avertissement; });
    },
    allDemandeSelected() {
      return this.demandes.every((demande) => {
        return demande.selected;
      });
    },
    getEtatDevis() {
      const etatFind = DEVIS_COMMANDE_ETAT.find((etat) => {
        return etat.code === this.devis.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : '';
    },
    getNameCommercial() {
      const utilisateur = this.users.find((user) => {
        return user.id === this.devis.commercialId;
      });
      return utilisateur ? utilisateur.decorator.nomPrenom : this.$i18n.t('listeDemandeTempo.card.noDefine');
    },
    getAllAgenceLibelle() {
      const agencesIdsProduit = [...new Set(this.demandes
        .map(demande => demande.ligneCommande.produit.agenceId))];
      const agences = this.societesInformations
        .map(s => s.agences).flat()
        .filter(a => agencesIdsProduit.includes(a.id));
      return agences.map(a => a.libelle).join(', ');
    },
  },
  methods: {
    selectAll(select) {
      this.makeSelect(this.demandes.map(demande => demande.ligneId), select);
    },
    makeSelect(ligneIds, select) {
      this.$emit('updateSelectDemande', ligneIds, select);
    },
    updateEtatObtenuReponse(ligneId, etat) {
      this.$emit('updateEtatObtenuReponse', ligneId, etat);
    },
  },
};

</script>
